const turnstileHandler = function (next) {
	const turnstileSiteKey = process.env.MIX_CAPTCHA_SITEKEY;
	turnstile.render(next, {
		sitekey: turnstileSiteKey,
		// callback: function (token) {
		// 	console.log(`Challenge Success ${token}`);
		// },
	});
};

export default turnstileHandler;
